var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.562 15.256a21.159 21.159 0 0 0 7.438 1.193 21.159 21.159 0 0 0 7.438-1.194c1.864-.727 2.525-1.535 2.525-2v-3.555a10.357 10.357 0 0 1 -2.084 1.076 22.293 22.293 0 0 1 -7.879 1.302 22.36 22.36 0 0 1 -7.879-1.3 10.28 10.28 0 0 1 -2.084-1.078v3.55c0 .474.663 1.278 2.525 2.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.562 21.961a15.611 15.611 0 0 0 2.6.741 24.9 24.9 0 0 0 4.838.453 24.9 24.9 0 0 0 4.838-.452 15.614 15.614 0 0 0 2.6-.741c1.864-.727 2.525-1.535 2.525-2v-3.39a10.706 10.706 0 0 1 -1.692.825 23.49 23.49 0 0 1 -8.271 1.343 23.49 23.49 0 0 1 -8.271-1.348 10.829 10.829 0 0 1 -1.692-.825v3.393c0 .466.663 1.271 2.525 2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 30c5.5 0 9.963-1.744 9.963-3.894v-2.837a10.5 10.5 0 0 1 -1.535.762l-.157.063a23.487 23.487 0 0 1 -8.271 1.351 23.422 23.422 0 0 1 -8.271-1.351c-.054-.02-.106-.043-.157-.063a10.5 10.5 0 0 1 -1.535-.762v2.837c0 2.15 4.463 3.894 9.963 3.894z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 5.894,
    rx: 9.963,
    ry: 3.894
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.dbc9c16ddf720813f8149ee999c10886.svg";
export { ForwardRef as ReactComponent };